import { render, staticRenderFns } from "./PerformanceCard.vue?vue&type=template&id=4db98e30&scoped=true"
import script from "./PerformanceCard.vue?vue&type=script&lang=js"
export * from "./PerformanceCard.vue?vue&type=script&lang=js"
import style0 from "./PerformanceCard.vue?vue&type=style&index=0&id=4db98e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db98e30",
  null
  
)

export default component.exports